/**
 * The `FittedText` rule for DOM labels: a `[data-fit]` span is scaled down (never up) until it fits
 * its parent box — a long amount, a wide date, a three-line description in a two-line slot. Call
 * after every render; the transform is reset first so a shorter text grows back.
 */
export function fitTexts(root: ParentNode): void {
  for (const node of root.querySelectorAll<HTMLElement>("[data-fit]")) {
    node.style.transform = "";
    const box = node.parentElement;
    if (!box) continue;
    const width = node.scrollWidth;
    const height = node.scrollHeight;
    if (width <= 0 || height <= 0) continue;
    const scale = Math.min(1, box.clientWidth / width, box.clientHeight / height);
    if (scale < 0.999) node.style.transform = `scale(${scale})`;
  }
}
